
import { Box, Link, Stack, Typography, linkClasses, styled, typographyClasses } from "@mui/material";

/**
 * LinkBoxRoot is a styled component based on MUI's Stack component.
 * It provides a container with specific styling for background color,
 * border radius, box shadow, and padding. Additionally, it includes
 * focus-within styles to add a border and remove outline for focused
 * link elements.
 *
 * @component
 * @example
 * return (
 *   <LinkBoxRoot>
 *      content here 
 *   </LinkBoxRoot >
 * )
 *
 * 
 * */
export const LinkBoxRoot = styled(Stack, { target: 'LinkBoxRoot' })`
    background-color: #fff;
    border-radius: ${({ theme }) => theme.spacing(1)};
    box-shadow: 0px 1px 8px rgb(var(--mui-palette-primary-mainChannel) / 0.12);
    padding: ${({ theme }) => theme.spacing(2, 3)};   
    gap: ${({ theme }) => theme.spacing(1)}; 
    &:focus-within {
        outline: ${({ theme }) => `1px solid ${theme.vars.palette.primary.main}`};
        .${linkClasses.focusVisible} {
            outline: none;
        }
    }
`

/**
 * TitleBox is a styled component based on MUI's Box component.
 * 
 * It provides a container with specific styling for margin, font size,
 * text decoration, cursor, and color. Additionally, it includes
 * 
 * @component
 * @example
 * return (
 *  <TitleBox>
 *     content here
 * </TitleBox>
 * )
 */
export const TitleBox = styled(Box, { target: 'TitleBox' })`
    margin-bottom: ${({ theme }) => theme.spacing(0.5)};
    .${typographyClasses.root} {
        text-decoration: underline;
        cursor: pointer;
        color: ${({ theme }) => theme.vars.palette.primary.main};
        font-size: 14px;
    }
`

export const LinkWidget = styled(Link, { target: 'WidgetLink' })`
    &.${typographyClasses.root} {
        color: ${({ theme }) => theme.vars.palette.primary.main};
        font-size: 14px;
    }
`


/**
 * SubTitleBox is a styled component based on MUI's Box component.
 * 
 * It provides a container with specific styling for font size and color.
 * 
 * @component
 * @example
 * return (
 * <SubTitleBox>
 *    content here
 * </SubTitleBox>
 * )
 */
export const AdditionalTextStyle = styled(Typography, { target: 'AdditionalTextStyle' })`
        color: ${({ theme }) => theme.vars.palette.texts.action} !important;
        font-size: 12px;    
`
/**
 * ErrorBox is a styled component based on MUI's Box component.
 * 
 * It provides a container with specific styling for font size and color.
 * 
 * @component
 * @example
 * return (
 * <ErrorBox>
 *   content here
 * </ErrorBox>
 * )
 */
export const LinkErrorStyle = styled(Typography, { target: 'LinkError' })`
        color: ${({ theme }) => theme.vars.palette.red[900]} !important;
        font-size: 12px;
`